import { AUTHENTICATION_URL } from "../ENVIRONMENT";

async function forgotPassword(userdetails) {
  // api for forgot password
  const response = await fetch(AUTHENTICATION_URL + "forgot", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(userdetails),
  });
  return response;
}
export { forgotPassword };
